export default __webpack_public_path__ + "static/media/SD-rudrabhishekam-img.7c3889a9.png";